module.exports = __webpack_public_path__ + "img/ring_g_c_null_1@2x.2f53de7d.png";